<vp-image
	[image]="{
		src: image().src,
		altText: image().alt,
		width: width(),
		height: height(),
	}"
	className="absolute inset-0 size-full cursor-pointer"
/>
@if (overlayCount(); as count) {
	<div
		class="overlay-dark-3 absolute inset-0 flex cursor-pointer items-center justify-center text-center font-display font-carousel text-white"
		data-test-id="image-grid__show-all"
	>
		<span aria-hidden="true" class="sm:hidden"> +{{ count.hidden }} </span>
		<span class="max-sm:sr-only">
			{{
				'compositions.image-grid.show-all-photos'
					| translate: { amount: count.total }
			}}
		</span>
	</div>
}
